export const PASSPORT_NOT_EXISTS_ERROR =
  'Query failed with (18): alloc::string::String not found: query wasm contract failed: invalid request';
